import React from 'react'

export default function Getstartcenter() {
  return (
    <div className=" w-[1347px] h-[623px] sm:h-[700px] my:w-[1200px] ipad:w-[700px] sm:w-[330px]  mt-[69px] ml-[41px] mr-[50px] bg-[#1a492780] rounded-[50px]" >
             <div className="pt-[134px] ipad:pt-[70px]  ml-[120px] ipad:ml-[80px] sm:ml-[20px]">
      <p className=" w-[769px] ipad:w-[550px] sm:w-[300px]   [font-family:'Inter-Bold',Helvetica] font-bold text-transparent text-[60px] sm:text-[20px] tracking-[-0.90px] leading-[73.7px] sm:leading-[35px]">
        <span className="text-[#00ff95]">Liam </span>
        <span className="text-[#a0ffd7]">can help you unleash your yield potential.</span>
      </p>
      <p className="mt-[30px] w-[1039px] ipad:w-[500px] sm:w-[300px] top-0 left-0 [font-family:'Inter-Regular',Helvetica] font-normal text-white text-[20px] tracking-[-0.30px] leading-[35px]">
        Meet Liam: Your Digital Agronomy Collaborator, Boost The Efficacy Of Your Field Productivity, And Bring New
        Ideas To Uncover Yield Potential.
      </p>
      <p className="mt-[13px] w-[1049px] ipad:w-[500px] sm:w-[300px] top-0 left-0 [font-family:'Inter-Regular',Helvetica] font-normal text-white text-[20px] tracking-[-0.30px] leading-[35px]">
        Liam Is An Experiment That Does Not Yet Incorporate Data About Your Specific Farm And May Give Inaccurate
        Responses. We Appreciate You Helping Us Make Liam Better.
      </p>
      <div className='flex space-x-10 mt-[-10px] ml-[756px] ipad:ml-[250px] sm:ml-[30px] sm:mt-[10px]'>
      <div className=" w-[112px] h-[34px]  bg-[#00ff95] rounded-[5.15px]" ><p className="h-[16px] mt-[9px] [font-family:'Inter-Medium',Helvetica] font-medium text-[#18663f] text-[12.9px] text-center tracking-[-0.19px] leading-[normal]">Login</p></div>
      <div className=" w-[112px] h-[34px] text-white rounded-[5.15px] border-[0.86px] border-solid border-white" ><p className=" mt-[9px] h-[16px]  [font-family:'Inter-Medium',Helvetica] font-medium text-white text-[12.9px] text-center tracking-[-0.19px] leading-[normal]">Register</p></div>
      </div>
    </div>
    
    </div>
  )
}
